<div class="ui-g pie-container">
  <div class="p-col-12">{{headerStr}}</div>
  <div class="p-col-12">
    <p-chart type="pie" [data]="buildData"></p-chart>
  </div>
</div>